import { ApiQuery, ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { CouponDataSource } from "./CouponDataSource";
import { CreateCouponRequest } from "@/data/dtos/requests";
import { CouponResponse } from "@/data/dtos/responses";
import { NotFoundError } from "@/domain/errors";
import { UpdateCouponInput } from "@/domain/dtos/inputs";
import { ValidateCouponResult } from "@/domain/entities";

export class CouponRemoteDataSource implements CouponDataSource {
  constructor(private readonly api: ApiService) {}

  async createCoupon(
    params: CreateCouponRequest,
  ): Promise<{ message: string }> {
    const { message } = await this.api.post(Endpoints.coupons, params);

    return { message: message || "Código criado com sucesso" };
  }
  async getCoupons(query?: ApiQuery): Promise<CouponResponse[]> {
    const { data } = await this.api.get<CouponResponse[]>(
      Endpoints.coupons,
      query,
    );

    if (!data) return [];

    return data;
  }

  async getCouponById(id: number): Promise<CouponResponse> {
    const { data } = await this.api.get<CouponResponse>(
      `${Endpoints.coupons}/${id}`,
    );

    if (!data) throw new NotFoundError("Cupom");

    return data;
  }
  async updateCoupon(
    id: number,
    params: UpdateCouponInput,
  ): Promise<{ message: string }> {
    const { message } = await this.api.put(
      `${Endpoints.coupons}/${id}`,
      params,
    );

    return { message: message || "Código alterado com sucesso" };
  }

  async deleteCoupon(id: number): Promise<{ message: string }> {
    const { message } = await this.api.delete(`${Endpoints.coupons}/${id}`);

    return { message: message || "Código removido com sucesso" };
  }

  async validateCoupon(
    code: string,
    psychologistId: number,
    recurrency?: boolean,
    first_appointment?: boolean,
  ): Promise<ValidateCouponResult> {
    const response = await this.api.post<
      unknown,
      { code: string; psychologist_id: number; recurrency?: boolean; first_appointment?: boolean }
    >(Endpoints.check_coupon, {
      code,
      psychologist_id: psychologistId,
      ...(recurrency !== undefined && { recurrency }),
      ...(first_appointment !== undefined && { first_appointment }),
    });

    return response as ValidateCouponResult;
  }
}
